// Phase 2: マスター層 write 経路（新エンドポイント）の fetch ラッパ
// 旧 update_lessons は LessonEditPage が直接 fetch している。こちらは新画面専用。
// 設計: lesson_model_redesign_memo.md 8.4

const apiUrl = process.env.REACT_APP_API_URL;

const handleResponse = async (response) => {
  let data = null;
  try {
    data = await response.json();
  } catch (_) {
    // ignore parse error
  }
  if (!response.ok) {
    const message = (data && data.error) || `HTTP ${response.status}`;
    const err = new Error(message);
    err.status = response.status;
    err.data = data;
    throw err;
  }
  return data;
};

// -------- LessonContent CRUD --------

export const fetchLessonContents = async () => {
  const res = await fetch(`${apiUrl}/api/get_lesson_contents/`, {
    method: "GET",
    credentials: "include",
  });
  return handleResponse(res);
};

export const createLessonContent = async (payload) => {
  const res = await fetch(`${apiUrl}/api/create_lesson_content/`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  return handleResponse(res);
};

export const updateLessonContent = async (contentId, payload) => {
  const res = await fetch(
    `${apiUrl}/api/update_lesson_content/${contentId}/`,
    {
      method: "PUT",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  );
  return handleResponse(res);
};

export const deleteLessonContent = async (contentId) => {
  const res = await fetch(
    `${apiUrl}/api/delete_lesson_content/${contentId}/`,
    {
      method: "DELETE",
      credentials: "include",
    }
  );
  return handleResponse(res);
};

// -------- LessonPlacement get + upsert --------

export const fetchLessonPlacements = async (studioId) => {
  const res = await fetch(
    `${apiUrl}/api/get_lesson_placements/?studio_id=${encodeURIComponent(studioId)}`,
    {
      method: "GET",
      credentials: "include",
    }
  );
  return handleResponse(res);
};

export const upsertLessonPlacements = async ({
  studioId,
  placements,
  deletedPlacementIds = [],
}) => {
  const res = await fetch(`${apiUrl}/api/upsert_lesson_placements/`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      studio_id: studioId,
      placements,
      deleted_placement_ids: deletedPlacementIds,
    }),
  });
  return handleResponse(res);
};

// -------- 既存 API の流用（読み取り専用） --------

// スタジオ一覧（既存 /api/get_studios_list/ を流用）
export const fetchStudiosList = async () => {
  const res = await fetch(`${apiUrl}/api/get_studios_list/`, {
    method: "GET",
    credentials: "include",
  });
  return handleResponse(res);
};

// 講師一覧（既存 /api/get_page_instructor_content/ を流用）
export const fetchInstructorsList = async () => {
  const res = await fetch(`${apiUrl}/api/get_page_instructor_content/`, {
    method: "GET",
    credentials: "include",
  });
  return handleResponse(res);
};

// Phase 1.1 で 'monday' 形式に統一（既存テーブル/フロントと整合）
export const DAY_OPTIONS = [
  { value: "monday", label: "月" },
  { value: "tuesday", label: "火" },
  { value: "wednesday", label: "水" },
  { value: "thursday", label: "木" },
  { value: "friday", label: "金" },
  { value: "saturday", label: "土" },
  { value: "sunday", label: "日" },
];
